import { Component, OnInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';

import { HCPGroupService } from '../../services/hcpgroup.service';
import { BasicError, Error403 } from '../../models/error/error';
import { Study } from '../../models/study';


@Component({
  selector: 'app-collaborating-studies',
  templateUrl: './collaborating-studies.component.html',
  styleUrls: ['./collaborating-studies.component.css']
})
export class CollaboratingStudiesComponent implements OnInit {
  public myStudies: Study[] = [];

  constructor(private hcpGroup: HCPGroupService, private naviService: NaviService) {
    hcpGroup.getCollaboratingStudies().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('An error occured while reading the collaborating studies.');
      } else {
        this.myStudies = this.myStudies.concat(data);
      }
    });
  }

  ngOnInit() {
  }

  public navigate(id: String) {
    this.naviService.navigateToUrl('hcp/managing-groups/' + id + '/detail', 'mygroups');
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/collaborating-studies/collaborating-studies.component.ts